export const getUserRole = state => state?.user?.user?.role?.name;
export const getUser = state => state?.user?.user?.profile;
